var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7833 8.30215C17.0929 8.67938 17.0678 9.26317 16.7272 9.6061L10.6161 15.7599C10.2983 16.08 9.81285 16.08 9.495 15.7599L7.27278 13.5222C6.93223 13.1793 6.90713 12.5955 7.21672 12.2182C7.52631 11.841 8.05335 11.8132 8.3939 12.1561L10.0556 13.8294L15.6061 8.24006C15.9466 7.89713 16.4737 7.92493 16.7833 8.30215Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.7368C16.8252 20.7368 20.7368 16.8252 20.7368 12C20.7368 10.6836 20.4457 9.43529 19.9244 8.31579C19.2193 6.80189 18.0932 5.52364 16.6966 4.63158C15.3402 3.76526 13.7288 3.26316 12 3.26316C7.17478 3.26316 3.26316 7.17478 3.26316 12C3.26316 16.8252 7.17478 20.7368 12 20.7368ZM12 22C17.5228 22 22 17.5228 22 12C22 10.4958 21.6679 9.0692 21.073 7.78947C20.2474 6.01346 18.9157 4.52036 17.2632 3.49549C15.7344 2.5474 13.9311 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.b8f38af7.svg";
export { ForwardRef as ReactComponent };